export type SortDirection = 'asc' | 'desc';

/**
 * The API's paged-fetch model binder reads the sort field from `sortBy` and the sort direction from
 * `sort` (compared literally against 'asc'). It never reads `sortDescending` or `sortDirection` —
 * those are discarded without an error, so a hook that sends them silently gets the endpoint's
 * default ordering instead. Building the params here keeps that contract in one place and makes the
 * wrong param names fail to type-check at the call site.
 */
export function buildPagedSortQueryParams({
	pageSize,
	pageToken,
	sortBy,
	sort,
	expand,
}: {
	pageSize: number;
	/** Opaque cursor — `useInfiniteQuery` types its page param as `unknown`. */
	pageToken?: unknown;
	/** Must be a field the endpoint's `[Sort]` attribute lists, otherwise the API falls back to its default. */
	sortBy?: string;
	sort?: SortDirection;
	expand?: string;
}) {
	return { pageSize, pageToken, sortBy, sort, expand };
}
